import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { FormControl, FormGroup } from '@angular/forms'
import { organizationFilter } from '../../models/organizations.model'
import { Subscription } from 'rxjs'
import {
	ActivationStatus,
	BusinessStatus,
} from 'src/app/shared/enums/general.enum'

@Component({
	selector: 'app-organization-filter',
	templateUrl: './organization-filter.component.html',
	styleUrls: ['./organization-filter.component.scss'],
})
export class OrganizationFilterComponent implements OnInit {
	@Output() emitFilter = new EventEmitter()
	@Output() emitfilterCount = new EventEmitter()
	@Input() filterData: organizationFilter = {
		paging: { pageNumber: 1, pageSize: 10 },
		SearchText: '',
		startDate: '',
		endDate: '',
		includeActive: null,
		includeInActive: null,
		countryId: null,
		status: 0,
		includeSalon: null,
		includeStore: null,
	}
	subscription = new Subscription()
	filterForm: FormGroup = new FormGroup({})

	filterCount = 0
	activeStatus = ActivationStatus
	businessStatus = BusinessStatus

	constructor() {}

	ngOnInit(): void {
		this.initForm()
		this.filterForm.valueChanges.subscribe((val) => {
			this.filterCount = 0

			for (let value in val) {
				if (
					(this.getController(value).value ||
						this.getController(value).value == 0) &&
					this.getController(value).value != false
				)
					this.filterCount += 1
			}
		})
	}
	ngOnChanges() {}
	initForm() {
		this.filterForm = new FormGroup({
			startDate: new FormControl(this.filterData.startDate || null),
			endDate: new FormControl(this.filterData.endDate || null),
			includeActive: new FormControl(this.filterData.includeActive || null),
			includeInActive: new FormControl(this.filterData.includeInActive || null),
			salon: new FormControl(this.filterData.includeSalon || null),
			store: new FormControl(this.filterData.includeStore || null),
		})
	}
	submit() {
		this.filterData = {
			...this.filterData,
			...this.filterForm.getRawValue(),
			startDate: this.getController('startDate')?.value
				? new Date(this.getController('startDate')?.value).toISOString()
				: null,
			endDate: this.getController('endDate')?.value
				? new Date(this.getController('endDate')?.value).toISOString()
				: null,
			includeActive: this.getController('includeActive')?.value
				? this.getController('includeActive')?.value
				: this.getController('includeInActive')?.value
				? false
				: null,
			includeInActive: this.getController('includeInActive')?.value
				? this.getController('includeInActive')?.value
				: this.getController('includeActive')?.value
				? false
				: null,
			salon: this.getController('salon')?.value
				? this.getController('salon')?.value
				: this.getController('store')?.value
				? false
				: null,

			store: this.getController('store')?.value
				? this.getController('store')?.value
				: this.getController('salon')?.value
				? false
				: null,
		}
		this.emitFilter.emit(this.filterData)
		this.emitfilterCount.emit(this.filterCount)
	}

	getController(controlName: string) {
		return (this.filterForm as FormGroup).controls[controlName] as FormControl
	}
	resetFilter() {
		this.filterForm.reset()
		this.filterData = {
			...this.filterData,
			...this.filterForm.getRawValue(),
		}
		this.getController('includeActive')
		this.emitFilter.emit(this.filterData)
		this.emitfilterCount.emit(this.filterCount)
	}

	ngOnDestroy() {
		this.subscription.unsubscribe()
	}
}
